import { assoc, overEvery } from 'lodash/fp';

import {
	LOGIN_EXPIRES_SOON,
	SESSION_EXPIRED,
	UPDATE_LOGIN_STATUS,
	USER_LOGGED_IN,
	USER_LOGOUT,
} from './actions';
import {
	PROP_IS_LOGGED_IN,
	PROP_IS_LOGGING_OUT,
	PROP_LOGIN_EXPIRES_SOON,
	PROP_USER_ACCOUNT_TYPE,
	PROP_USER_ID,
} from './constants';
import { getTokenData, isValidAccessToken } from './utils/accessTokenUtils';

const initialState = {
	[PROP_IS_LOGGED_IN]: overEvery([isValidAccessToken, (tokenData) => tokenData.fullAccess])(
		getTokenData()
	),
	[PROP_IS_LOGGING_OUT]: false,
	[PROP_USER_ID]: undefined,
};

function authReducer(state = initialState, { type, payload }) {
	switch (type) {
		case SESSION_EXPIRED:
		case USER_LOGOUT:
			// property `isLoggingOut` displays full page loader until the `logout` saga finishes cleanup.
			// This flag will be unset by saga's hard redirect to logout screen, thus by completely wiping
			// out application data
			return assoc(PROP_IS_LOGGING_OUT, true, state);
		case UPDATE_LOGIN_STATUS:
			return assoc(PROP_IS_LOGGED_IN, payload.isLoggedIn, state);
		case USER_LOGGED_IN: {
			return {
				...state,
				[PROP_USER_ID]: payload.user.id,
				[PROP_USER_ACCOUNT_TYPE]: payload.user.accountType,
			};
		}
		case LOGIN_EXPIRES_SOON:
			return {
				...state,
				[PROP_LOGIN_EXPIRES_SOON]: payload.loginExpiresSoon,
			};
		default:
			return state;
	}
}

export default authReducer;
